<template>
    <v-row>
      <div class="col-md-12 home-box">
        <Breadcrumbs :title="'Stores'"></Breadcrumbs>
        <StoreList></StoreList>
      </div>
      <div class="col-md-12 home-tabs-body">
      </div>
    </v-row>
  </template>
  
  <script>
  
  import StoreList from "@/components/storesAndStocks/StoreList";
  import { createNamespacedHelpers } from "vuex";
  import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
  const { mapGetters } = createNamespacedHelpers("auth");
  
  export default {
    name: "Inventories",
    components: {
        StoreList,
      Breadcrumbs
    },
    data: function () {
      return {
      };
    },
    computed: {
      ...mapGetters({
        loading: "loading",
        profile: "profile"
      })
    },
    mounted() {
      this.$store.dispatch("auth/getProfile");
    },
  
    watch: {
  
    },
  
    methods: {
  
    },
  
  };
  </script>